import styled from 'styled-components'
import { TTextColor } from './types'

export const Text = styled.div<TTextColor>`
   color: ${({ color }) => color};
`
